/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function GridServiceConstructor (
    this: JS5Object,
    _: JS5Object,
    $timeout: JS5Function,
    uiGridSaveStateService: JS5Object,
) {

    //=========================//
    // Automatic Data Handling //
    //=========================//

    const getFullStorageKey = (storageKeyName: string | JS5Function) => {
        let trueKeyName: string;
        if (typeof(storageKeyName) === 'function') {
            trueKeyName = storageKeyName();
        } else {
            trueKeyName = storageKeyName;
        }
        return `grid.columns.${trueKeyName}`
    };

    this.manageSavedColumns = (
        scope: ng.IScope,
        gridApi: JS5Object,
        storageKeyName: string | JS5Function
    ) => {
        $timeout(() => {
            this.loadSavedColumns(gridApi, storageKeyName);
        });

        gridApi.colResizable.on.columnSizeChanged(scope, () => {
            this.saveCurrentColumns(gridApi, storageKeyName);
        });
    };


    //======================//
    // Manual Data Handling //
    //======================//

    this.loadSavedColumns = (
        gridApi: JS5Object,
        storageKeyName: string | JS5Function
    ) => {
        let storedSizeJson = localStorage[getFullStorageKey(storageKeyName)];
        if (storedSizeJson) {
            uiGridSaveStateService.restoreColumns(gridApi.grid, JSON.parse(storedSizeJson));
        }
    };

    this.saveCurrentColumns = (
        gridApi: JS5Object,
        storageKeyName: string | JS5Function
    ) => {
        let columnSizes = uiGridSaveStateService.saveColumns(gridApi.grid);
        localStorage[getFullStorageKey(storageKeyName)] = JSON.stringify(columnSizes);
    };
}

angular.module('prism-ui.components')
    .service('GridService', GridServiceConstructor);
